// extracted by mini-css-extract-plugin
export default {"root":"EndOfTheFlow_root__ZG7uy","checkCircle":"EndOfTheFlow_checkCircle__-clcV","link":"EndOfTheFlow_link__1B6Tw"};